// extracted by mini-css-extract-plugin
export default {"medicaidField":"MedicaidField_medicaidField__VFnmI"};